import React from "react";
import { Link } from "react-router-dom";
import "./AboutUs.css";

function AboutUsPage() {
  return (
    <div className="about-page">

      {/* Hero */}
      <section className="about-page-hero">
        <div className="about-page-hero-content" data-aos="fade-up">
          <span className="about-page-hero-tag">OUR STORY</span>
          <h1>
            About <span>Us</span>
          </h1>
          <p>Royal Bakers & Confectioners — A legacy of baking freshness since 1996.</p>
        </div>
      </section>

      {/* Story */}
      <section className="about-page-story">
        <div className="about-page-container">
          <div className="about-page-story-grid">
            <div className="about-page-story-media" data-aos="fade-right">
              <img
                src="https://images.unsplash.com/photo-1555507036-ab1f4038808a?w=800&h=900&fit=crop"
                alt="Freshly baked goods on display at Royal Bakery"
              />
              <div className="about-page-story-badge">
                <strong>Est.</strong> 1996
              </div>
            </div>

            <div className="about-page-story-text" data-aos="fade-left">
              <span className="about-page-tag">WHO WE ARE</span>
              <h2>
                A Legacy of Baking Since <span>1996</span>
              </h2>
              <p>
                Founded in 1996 in Aurangabad, Maharashtra, Royal Bakers &
                Confectioners has been serving customers with quality bakery and
                confectionery products for nearly three decades.
              </p>
              <p>
                Over the years, the company has grown from a local bakery into an
                expanding business with a wider vision for the future. Our journey
                has been shaped by years of experience in baking, an understanding
                of customer preferences, and the trust we have received from the
                people who have been with us along the way.
              </p>
              <p>
                At Royal Bakers & Confectioners, we offer a range of bakery and
                confectionery products made for everyday consumption as well as
                special occasions. We focus on maintaining consistency in taste,
                freshness, quality and hygiene, while continuously working on
                improving our products and processes.
              </p>
              <p>
                As the business grows, we are also expanding our capabilities to
                meet the changing needs of the market. We believe that a strong
                bakery business is built not only on good products, but also on
                dependable service, efficient operations and long-term relationships
                with customers, retailers and business partners.
              </p>

              <div className="about-page-story-features">
                <div className="about-page-feature">
                  <i className="ri-leaf-line"></i>
                  <span>Quality ingredients</span>
                </div>
                <div className="about-page-feature">
                  <i className="ri-time-line"></i>
                  <span>Baked fresh daily</span>
                </div>
                <div className="about-page-feature">
                  <i className="ri-heart-line"></i>
                  <span>Made with care</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Growth */}
      <section className="about-page-growth">
        <div className="about-page-container">
          <div className="about-page-section-head" data-aos="fade-up">
            <span className="about-page-tag">OUR JOURNEY</span>
            <h2>Growing Beyond <span>Aurangabad</span></h2>
          </div>

          <div className="about-page-growth-grid">
            <div className="about-page-growth-text" data-aos="fade-right">
              <p>
                After establishing our roots in Aurangabad, we are now entering an
                important phase of growth. Royal Bakers & Confectioners is working
                towards expanding its reach into new cities and markets across
                Maharashtra and India.
              </p>
              <p>
                Our aim is to build a strong distribution and supply network that
                allows more customers to experience our products. We are also open
                to working with distributors, retailers, wholesalers, food
                businesses and other partners as we expand.
              </p>
              <p>
                Our vision is to gradually take Royal Bakers & Confectioners from
                a trusted regional name to a bakery brand serving customers
                across India.
              </p>
            </div>

            <div className="about-page-growth-panel" data-aos="fade-left">
              <h3>Open to Partnerships</h3>
              <p>We are looking for partners who share our vision of growth:</p>
              <ul className="about-page-growth-partners">
                <li><i className="ri-store-2-line"></i> Distributors</li>
                <li><i className="ri-shopping-bag-3-line"></i> Retailers</li>
                <li><i className="ri-briefcase-4-line"></i> Wholesalers</li>
                <li><i className="ri-restaurant-line"></i> Food Businesses</li>
                <li><i className="ri-community-line"></i> Distribution Networks</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Ahead */}
      <section className="about-page-ahead">
        <div className="about-page-container">
          <div className="about-page-ahead-inner" data-aos="zoom-in-up">
            <span className="about-page-tag">LOOKING AHEAD</span>
            <h2>Looking <span>Ahead</span></h2>
            <p>
              While our business continues to grow, our approach remains simple —
              make good products, maintain quality, serve customers well and keep
              improving.
            </p>
            <p>
              The journey that began in Aurangabad in 1996 is continuing into a
              new chapter. With the experience of the past and a clear vision for
              the future, Royal Bakers & Confectioners is getting ready to serve
              customers across India soon.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="about-page-values">
        <div className="about-page-container">
          <div className="about-page-section-head" data-aos="fade-up">
            <span className="about-page-tag">OUR VALUES</span>
            <h2>
              What We <span>Stand For</span>
            </h2>
          </div>

          <div className="about-page-values-grid">
            <div className="about-page-value-card" data-aos="fade-up">
              <div className="about-page-value-icon">
                <i className="ri-award-line"></i>
              </div>
              <h3>Quality First</h3>
              <p>
                Every recipe begins with hand-picked, carefully sourced
                ingredients to guarantee exceptional taste, batch after batch.
              </p>
            </div>

            <div className="about-page-value-card" data-aos="fade-up" data-aos-delay="150">
              <div className="about-page-value-icon">
                <i className="ri-flashlight-line"></i>
              </div>
              <h3>Daily Freshness</h3>
              <p>
                We bake in small batches through the day so that what reaches
                your table is always crisp, soft, and deliciously fresh.
              </p>
            </div>

            <div className="about-page-value-card" data-aos="fade-up" data-aos-delay="300">
              <div className="about-page-value-icon">
                <i className="ri-community-line"></i>
              </div>
              <h3>Community</h3>
              <p>
                From local stores to your family gatherings, we're proud to be
                part of celebrations and everyday moments across the city.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Stats */}
      <section className="about-page-stats">
        <div className="about-page-container">
          <div className="about-page-stats-grid">
            <div className="about-page-stat" data-aos="zoom-in">
              <h3>30+</h3>
              <span>Years of Baking</span>
            </div>
            <div className="about-page-stat" data-aos="zoom-in" data-aos-delay="150">
              <h3>60+</h3>
              <span>Products</span>
            </div>
            <div className="about-page-stat" data-aos="zoom-in" data-aos-delay="300">
              <h3>10K+</h3>
              <span>Happy Customers</span>
            </div>
            {/* <div className="about-page-stat" data-aos="zoom-in" data-aos-delay="450">
              <h3>4</h3>
              <span>Bakeries</span>
            </div> */}
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="about-page-cta">
        <div className="about-page-container">
          <div className="about-page-cta-card" data-aos="zoom-in-up">
            <span className="about-page-cta-brand">Royal Bakers &amp; Confectioners</span>
            <h3 className="about-page-cta-tagline">Since 1996 | Aurangabad, Maharashtra</h3>
            <p className="about-page-cta-desc">
              From our bakery in Aurangabad to homes and businesses across India —
              we are growing, one step at a time.
            </p>
            <div className="about-page-cta-buttons">
              <Link to="/products" className="about-page-btn about-page-btn--solid">
                Explore Products
              </Link>
              <Link to="/contact" className="about-page-btn about-page-btn--ghost">
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AboutUsPage;